// Проверяем, умеет ли текущее устройство/браузер захватывать экран (getDisplayMedia).
// Мобильные браузеры (iOS/Android) не поддерживают захват экрана из веб-страницы.
export const isScreenShareSupported = () => {
	if (typeof navigator === 'undefined' || !navigator.mediaDevices) {
		return false;
	}

	if (!('getDisplayMedia' in navigator.mediaDevices)) {
		return false;
	}

	const ua = navigator.userAgent;
	const isMobile = /Android|iP(hone|ad|od)/.test(ua);

	return !isMobile;
};
